import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';
import { AuthProvider } from './hook_au/useAuth.tsx';
import { AppSettingsProvider } from './hook/useAppSettings.tsx';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AuthProvider>
      <AppSettingsProvider>
        <App />
      </AppSettingsProvider>
    </AuthProvider>
  </React.StrictMode>,
);
